// unit-c-frontend/src/services/mediaService.js
import api from '../api';

const mediaService = {
    upload: (file, mediaType, onUploadProgress) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('media_type', mediaType);
        return api.post('/media-files', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: onUploadProgress
                ? (progressEvent) => {
                    const percent = progressEvent.total
                        ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        : 0;
                    onUploadProgress(percent);
                }
                : undefined,
        });
    },

    list: (type) => {
        const params = type ? { type } : {};
        return api.get('/media-files', { params });
    },

    remove: (id) => api.delete(`/media-files/${id}`),
};

export default mediaService;
